import { z } from 'zod';

import { DefinitionItem } from './language';

export const Department = z.object({
  id: z.string().default(''),
  name: z.string().default(''),
  enabled: z.boolean().default(false),
  createdAt: z.string().default(''),
  updatedAt: z.string().default(''),
  definitions: z.array(DefinitionItem).default([]),
});
export type DepartmentType = z.infer<typeof Department>;
